import { render, staticRenderFns } from "./fccAbaInserirPagamento.vue?vue&type=template&id=50164372"
import script from "./fccAbaInserirPagamento.vue?vue&type=script&lang=js"
export * from "./fccAbaInserirPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports